import {
  FETCH_LIBERTY_REVIEW,
  FETCH_LIBERTY_REVIEW_SUCCESS,
  FETCH_LIBERTY_REVIEW_FAILURE,
  RECORD_LIBERTY_DECISION,
  RECORD_LIBERTY_DECISION_SUCCESS,
  RECORD_LIBERTY_DECISION_FAILURE,
} from "./constants";

const initialState = {
  isFetching: false,
  // The location the rows belong to — switching home must not leave the
  // previous home's residents on screen.
  locationId: null,
  // [{ resident, liberty_status, decision, authorisation, agni_review }, …]
  // `null` = never loaded (distinct from `[]` = loaded and genuinely empty).
  rows: null,
  // { total, pre_agni_open, deprived_unauthorised, not_screened }
  counts: null,
  fetchedAt: null,
  error: null,
  // Authorisation uuid whose decision POST is in flight — one at a time, so
  // the row's own buttons can disable without freezing the whole page.
  savingUuid: null,
};

const LibertyReviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LIBERTY_REVIEW: {
      const nextLocation = action.payload?.locationId ?? state.locationId;
      const locationChanged = nextLocation !== state.locationId;
      return {
        ...state,
        isFetching: true,
        error: null,
        locationId: nextLocation,
        rows: locationChanged ? null : state.rows,
        counts: locationChanged ? null : state.counts,
      };
    }

    case FETCH_LIBERTY_REVIEW_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        locationId: action.payload?.locationId ?? state.locationId,
        rows: action.payload?.rows ?? [],
        counts: action.payload?.counts ?? null,
        fetchedAt: action.payload?.fetchedAt ?? null,
      };

    case FETCH_LIBERTY_REVIEW_FAILURE:
      return { ...state, isFetching: false, error: true };

    case RECORD_LIBERTY_DECISION:
      return {
        ...state,
        savingUuid: action.payload?.authorisationUuid ?? null,
      };

    case RECORD_LIBERTY_DECISION_SUCCESS: {
      const {
        authorisationUuid,
        libertyStatus,
        agniReview,
        agniReviewReturned,
      } = action.payload || {};
      if (!authorisationUuid || !Array.isArray(state.rows)) {
        return { ...state, savingUuid: null };
      }
      return {
        ...state,
        savingUuid: null,
        // Merge in place rather than refetching: the queue is home-wide and a
        // refetch would re-sort every row out from under the person who just
        // acted on one.
        rows: state.rows.map((row) => {
          if (row?.authorisation?.uuid !== authorisationUuid) return row;
          return {
            ...row,
            liberty_status: libertyStatus ?? row.liberty_status,
            // `agni_review: null` is meaningful — the review closed. Only keep
            // the previous value when the server omitted the key entirely.
            agni_review: agniReviewReturned ? agniReview : row.agni_review,
          };
        }),
      };
    }

    case RECORD_LIBERTY_DECISION_FAILURE:
      return { ...state, savingUuid: null };

    default:
      return state;
  }
};

export default LibertyReviewReducer;
